/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type CollectiveAgreementPageContentResponseModelContentType = typeof CollectiveAgreementPageContentResponseModelContentType[keyof typeof CollectiveAgreementPageContentResponseModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollectiveAgreementPageContentResponseModelContentType = {
  collectiveAgreementPage: 'collectiveAgreementPage',
} as const;
